import { render, staticRenderFns } from "./user-list-page.vue?vue&type=template&id=247d7afb&"
import script from "./user-list-page.vue?vue&type=script&lang=ts&"
export * from "./user-list-page.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports